import removeDuplicateObjects from 'assets/js/utilities/removeDuplicateObjects'

// eventTaskUpdated(data, modelContext)
export default function eventTaskUpdatedMoveTask({ author, user, task }, contexts, callback) {  
  if (author?.id === user?.id) return;  // Don't move tasks
  
  contexts.forEach( async ({ dataset, dispatch, prop, update }) => {
    // FIND THE NEW TASK IN ITS OLD BUCKET
    const bucketIdx = dataset.findIndex(bucket => bucket.tasks?.data?.find(_task => _task.id === task.id));
    const taskIdx = dataset.at(bucketIdx).tasks.data.findIndex(_task => _task.id === task.id);

    if (! [bucketIdx, taskIdx].find(el => [-1, undefined].includes(el)) && dataset.at(bucketIdx).tasks?.data) {  // THE TASK MIGHT NOT BE IN MEMORY FOR A USER  
      // REMOVE FROM OLD BUCKET
      dataset.at(bucketIdx).tasks.data.splice(taskIdx, 1);
    }

    // ADD TO NEW BUCKET
    const newBucketIdx = dataset.findIndex(bucket => bucket.id === task.bucket_id);
    dataset.at(newBucketIdx).tasks.data.splice(0, 0, task);
      
    // REMOVE DUPLICATES
    dataset.at(newBucketIdx).tasks.data = removeDuplicateObjects(dataset.at(newBucketIdx).tasks.data, 'id', 'updated_at');

    // SORT
    dataset.at(newBucketIdx).tasks.data.sort((a, b) => a.order_index > b.order_index ? 1 : -1);

    // UPDATE CONTEXT
    await update(dispatch, { [prop]: dataset });

    callback();
  });
}